import { render, staticRenderFns } from "./StdDetailPage.vue?vue&type=template&id=0c7c682d&scoped=true&"
import script from "./StdDetailPage.vue?vue&type=script&lang=js&"
export * from "./StdDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./StdDetailPage.vue?vue&type=style&index=0&id=0c7c682d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c682d",
  null
  
)

export default component.exports